<template>
	<div class="LhTop">
		<div class="LhHead">
			<div class="logo"><img :src="src"></img></div>
			<div class="lg-btn">
				<el-button-group>
				  <el-button type="primary" size="medium">免费注册</el-button>
				  <el-button size="medium">登录</el-button>
				</el-button-group>
			</div>
		</div>
		<div class="banner-contain">
			<div class="lh-search">
				<el-input placeholder="请输入内容" v-model="input2">
				    <el-button slot="append" icon="el-icon-search"></el-button>
				</el-input>
			</div>
			<div class="hot-word">
				<el-link href="#" target="_blank">技工</el-link>
				<el-link href="#" target="_blank">安保/家政</el-link>
				<el-link href="#" target="_blank">影视</el-link>
				<el-link href="#" target="_blank">艺术</el-link>
				<el-link href="#" target="_blank">服装设计</el-link>
				<el-link href="#" target="_blank">公务员</el-link>
				<el-link href="#" target="_blank">科研</el-link>
				<el-link href="#" target="_blank">志愿者</el-link>
				<el-link href="#" target="_blank">实习生</el-link>
				<el-link href="#" target="_blank">兼职</el-link>
			</div>
		</div>
		<div class="LhMain">
			<div class="LhMain-title"><img :src="titlesrc" alt="" /></div>
			<div class="LhMain-taps">
				<div class="taps-item">
					<ul>
					    <li @click="change(index)" :class="[currentindex==index?'active':'']" :key="item.id" v-for="(item,index) in list">{{item.text}}</li>
					</ul>
				</div>
				<div class="taps-comtain">
					<div class="dn" :class="[currentindex==index?'current':'']" v-for="(item,index) in list">
					    <div class="taps-comtain-box">
							<el-row :gutter="24">
								<el-col :span="8" v-for="(pcd,index) in personlist">
									<el-card :body-style="{ padding: '0px'}">
										<div class="box-card">
											<div class="card-body">
												<div class="card-body-top">
													<div class="card-body-img"><img :src="pcd.headimg" alt="" /></div>
													<div class="card-body-txt">
														<div class="card-body-name">{{pcd.name}}</div>
														<div class="card-body-ed">{{pcd.old}}岁 · {{pcd.WorkExperience}} · {{pcd.educational}}</div>
													</div>
												</div>
												<div class="card-body-qw">期望：<span>{{pcd.position}}</span><span>{{pcd.district}}</span><span>{{pcd.salary}}</span></div>
											</div>
											<div class="card-qrcode"><img :src="pcd.qrcode" alt="" /> <br/>查看作品</div>
										</div>
									</el-card>
								</el-col>
							</el-row>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>

export default {
  name: 'LhAi',
  props: {
    msg: String
  },
  data() {
  	return {
		src:require('@/assets/logo.png'),
		titlesrc:require('@/assets/title.png'),
		currentindex:'0',//当前选项卡的索引
		list:[{
			id:'1',
			text:'AI短剧制作',
			imgsrc:'imgs/1.jpg'
		},{
			id:'2',
			text:'电商直播',
			imgsrc:'imgs/2.jpg'
		},{
			id:'3',
			text:'户外活动',
			imgsrc:'imgs/3.jpg'
		}],
		personlist:[{
			id:'1',
			headimg:require('@/assets/headimg.png'),
			name:'罗先生',
			sex:'1',
			old:'31',
			WorkExperience:'2-3年',
			educational:'本科',
			district:'椒江区',
			position:'行政专员/助理',
			salary:'9-10K',
			qrcode:require('@/assets/qrcodeimg.png'),
		},
		{
			id:'2',
			headimg:require('@/assets/headimg.png'),
			name:'罗先生',
			sex:'1',
			old:'31',
			WorkExperience:'2-3年',
			educational:'本科',
			district:'椒江区',
			position:'行政专员/助理',
			salary:'9-10K',
			qrcode:require('@/assets/qrcodeimg.png'),
		},
		{
			id:'3',
			headimg:require('@/assets/headimg.png'),
			name:'罗先生',
			sex:'1',
			old:'31',
			WorkExperience:'2-3年',
			educational:'本科',
			district:'椒江区',
			position:'行政专员/助理',
			salary:'9-10K',
			qrcode:require('@/assets/qrcodeimg.png'),
		},
		{
			id:'4',
			headimg:require('@/assets/headimg.png'),
			name:'罗先生',
			sex:'1',
			old:'31',
			WorkExperience:'2-3年',
			educational:'本科',
			district:'椒江区',
			position:'行政专员/助理',
			salary:'9-10K',
			qrcode:require('@/assets/qrcodeimg.png'),
		},]
	}
  },
  methods:{
		change:function(index){
		this.currentindex=index;
			 }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.LhTop{
	width: 100%;
	height: 90px;
	margin: 0px;
	padding: 0px;
	background-color: #fff;
}
.LhHead{
	margin: 0px auto;
	width: 1200px;
	padding: 12px 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 24px;
}
.logo{
	width: 300px;
	float: left;
}
.lg-btn{
	height: 36px;
	width: 170px;
}
.banner-contain{
	width:1200px;
	margin: 0px auto;
	display: flex;
	align-items: center;
	padding-top: 122px;
	height: 124px;
	background: url("../assets/banner-bg.png") repeat center center;
	flex-direction:column;
}
.lh-search{
	width: 600px;
	height: 40px;
	margin:0px auto;
}
.hot-word{
	width: 600px;
	padding-top: 12px;
	display: flex;
	justify-content: space-between;
}
.hot-word a{
	color:#ffffff;
}
.hot-word a:hover{
	color:#ffffff;
}
.LhMain{
	width: 1200px;
	margin: 0px auto;
}
.LhMain-title{
	padding-top: 24px;
}
.LhMain-taps{
        width:1200px;
        margin: 20px auto;
        position: relative;
		display: flex;
		flex-direction: column;
}
.LhMain-taps > .taps-item{
	width:1200px;
	background-color: #fff;
	margin: 0px auto;
	display: flex;
	justify-content: center;
	height: 60px;
}
.LhMain-taps > .taps-comtain{
	display: flex;
	position: relative;
	width: 1200px;
	padding-top: 24px;
	
}
.LhMain-taps > .taps-item > ul{
	width: 480px;
	display: flex;
	justify-content: space-between;
	height: 60px;
	line-height: 60px;
	margin:0px;
}
.LhMain-taps ul li{
	width: 100px;
	height: 60px;
	float: left;
	list-style: none;
	text-align: center;
	line-height: 60px;
	position: relative;
}
.LhMain-taps ul .active{
	color:blue;
}
.LhMain-taps ul .active::after{
	content:"";
	position: absolute;
	width: 100px;
	height: 2px;
	background-color: blue;
	bottom: 0px;
	left:0px;
}
.LhMain-taps div.dn{
	width: 1200px;
	display: none;
}
.LhMain-taps div.current{
	display: block;
}
.clearfix:before,
.clearfix:after {
	display: table;
	content: "";
}

.clearfix:after {
	clear: both
}
.box-card{
	display: flex;
	justify-content: space-between;
	padding: 12px;
}
.box-card > .el-card__body{
	display: flex;
	justify-content: space-between;
}
.card-body-top{
	height: 52px;
	display: flex;
	align-items: center;
	margin-bottom: 12px;
}
.card-body-img{
	width: 52px;
	height: 52px;
	margin-right: 12px;
}
.card-body-img img{
	width: 100%;
	display: block;
}
.card-body-txt{
	text-align: left;font-size: 13px;
}
.card-body-name{
	font-size: 18px;
	margin-bottom: 6px;
	font-weight: bold;
}
.card-body-qw{
	color: #898989;
	font-size: 13px;
	span{
		color:#333333;
		margin-right: 8px;;
	}
}
.card-qrcode{
	font-size: 14px;;
}
.el-col {
    margin-bottom: 24px;
  }
</style>
